import { render, staticRenderFns } from "./CodeWindow.vue?vue&type=template&id=1ff17dd2&"
import script from "./CodeWindow.vue?vue&type=script&lang=js&"
export * from "./CodeWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports